/**
 * ContentLoader
 * Fetches the URL in `data-src-content` and appends the response HTML into
 * the container matched by the `data-src-container` selector.
 *
 * <span class="lazy js-content-loader" data-src-content="/magazine/${reloadUrl}" data-src-container=".js-content-loader-container"></span>
 */
export default class ContentLoader {
  /**
   * @param {Element} target
   * @param {Function} [completeCallback]
   */
  constructor(target, completeCallback = () => {}) {
    this.url = target.dataset.srcContent;
    this.container = target.dataset.srcContainer;
    this.completeCallback = completeCallback;
    this.callApi(this.container, this.url);
  }

  /**
   * Loads content and appends it to the container.
   *
   * @param {String} container - CSS selector for the target container
   * @param {String} url
   */
  callApi(container, url) {
    lm.fetch({
      url: url,
      success: data => {
        document.querySelector(container).insertAdjacentHTML('beforeend', data);
      },
      complete: () => {
        this.completeCallback();
      }
    });
  }
}